import React, { useState } from "react";
import { Helmet } from "react-helmet";

function WhistleBlowing() {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      <Helmet>
            <title>Whistleblowing</title>
          
          </Helmet>
      <section className="w-full bg-white">
        <div className="max-w-4xl mx-auto py-36 px-5 text-black text-start">
            <h1 className="text-3xl font-bold text-center mb-10">Segnalazioni Whistleblowing</h1>
            <div>
                <p className="pb-5 font-bold">
                  Le segnalazioni, tramite canale interno, possono essere
                  effettuate:
                </p>
                <ul className="list-disc space-y-5 list-inside">
                  <li>
                    in forma scritta, a mezzo posta ordinaria o raccomandata
                    a/r, inviate all’indirizzo via G.E. Arimondi 33 – Milano
                    20155, all’attenzione dell’Avv. Andrea Polizzi, nella
                    seguente modalità: inserire la segnalazione in due buste
                    chiuse, includendo, nella prima, i dati identificativi del
                    segnalante, unitamente a un documento di identità; nella
                    seconda, l’oggetto della segnalazione; entrambe le buste
                    dovranno poi essere inserite in una terza busta riportando,
                    all’esterno, la dicitura “riservata al gestore della
                    segnalazione”, così da dare chiara indicazione della volontà
                    di volersi avvalere delle tutele garantite al whistleblower;
                  </li>
                  <li>
                    in forma orale, instaurando un contatto telefonico con il
                    gestore della segnalazione al numero 0255196161.
                  </li>
                </ul>
                <p className="py-5">
                  Tali modalità di segnalazione consentono a chiunque
                  (dipendenti e collaboratori, fornitori e qualsiasi altro
                  soggetto che abbia avuto od intenda avere rapporti d’affari
                  con la Società) di segnalare ipotesi di condotte illecite o
                  irregolarità, violazioni di norme, violazioni del Modello 231,
                  violazioni del Codice Etico e comunque violazioni di procedure
                  e disposizioni aziendali in genere.
                </p>
                <p>
                  Per visualizzare la procedura{" "}
                  <button
                    className="text-blue-500 font-bold"
                    onClick={() => setIsVisible(!isVisible)}
                  >
                    clicca qui
                  </button>
                </p>

                {isVisible && (
                  <div className="py-10">
                    <h3 className="text-2xl font-bold text-center">Procedura Whistleblowing per la segnalazione di illeciti</h3>
                    <p className="pb-5 pt-10">
                        Il processo di gestione della segnalazione effettuata ai
                        sensi del D. Lgs. 24/2023 si articola in:
                    </p>
                    <ul className="list-decimal space-y-5 list-inside">
                      <li>
                        ricezione della segnalazione. Entro sette giorni dalla
                        data di ricezione della Segnalazione, il Gestore
                        trasmette al Segnalante un avviso di ricevimento della
                        stessa, con cui ne comunica altresì la presa in carico e
                        l’avvio delle attività di verifica e di istruttoria;
                      </li>
                      <li>
                      analisi della segnalazione, intesa come esame della ricevibilità formale e successiva valutazione nel merito, con eventuale richiesta di informazioni integrative per completare l’istruttoria;
                      </li>
                      <li>
                      comunicazione dell’esito degli approfondimenti entro tre mesi dalla data di trasmissione dell’avviso di ricevimento o, in mancanza di tale avviso, entro tre mesi dalla data di scadenza del termine di sette giorni per tale avviso.
                      </li>
                    </ul>
                    <p className="py-5">Se, in considerazione del contenuto della Segnalazione e della complessità della stessa non fosse possibile concludere l’istruttoria entro i tre mesi previsti dal D. Lgs. 24/2023, il Gestore ne informa il Segnalante.</p>
                    <p className="font-bold py-5">Pertanto, alla scadenza dei tre mesi, il Gestore della Segnalazione può comunicare al Segnalante:</p>
                    <ul className="space-y-5 list-inside">
                      <li>
                      <span className="font-bold">a)</span> l’avvenuta archiviazione della segnalazione, motivandone le ragioni;
                      </li>
                      <li>
                      <span className="font-bold">b)</span> l’avvenuto accertamento della fondatezza della segnalazione e la sua trasmissione agli organi interni competenti;
                      </li>
                      <li>
                      <span className="font-bold">c)</span> l’attività svolta fino a questo momento e/o l’attività ulteriore che intende svolgere, con comunicazione finale dell’esito dell’istruttoria ai sensi delle lettere a) e b).
                      </li>
                    </ul>
                  </div>
                )}
              
            </div>
          
        </div>
      </section>
    </>
  );
}

export default WhistleBlowing;
